import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, Col, DatePicker, Row, Space, Statistic, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { api } from '@/lib/api';
import { formatRupiah } from '@/lib/format';
export function StockValuationPage() {
    const [asOf, setAsOf] = useState(dayjs());
    const q = useQuery({
        queryKey: ['stock-valuation', asOf.format('YYYY-MM-DD')],
        queryFn: async () => (await api.get('/reports/stock-valuation', {
            params: { as_of: asOf.format('YYYY-MM-DD') },
        })).data,
    });
    const cols = [
        { title: 'SKU', dataIndex: 'sku', width: 130 },
        { title: 'Nama Barang', dataIndex: 'name' },
        {
            title: 'Kategori',
            dataIndex: 'category',
            width: 160,
            render: (v) => v ?? '-',
        },
        {
            title: 'Qty',
            dataIndex: 'qty',
            width: 120,
            align: 'right',
            render: (v) => Number(v).toLocaleString('id-ID', { maximumFractionDigits: 3 }),
        },
        {
            title: 'HPP Rata2',
            dataIndex: 'avg_cost',
            width: 160,
            align: 'right',
            render: (v) => formatRupiah(v),
        },
        {
            title: 'Valuasi',
            dataIndex: 'valuation',
            width: 200,
            align: 'right',
            render: (v) => _jsx("b", { children: formatRupiah(v) }),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: "Valuasi Stok" }), _jsx(DatePicker, { value: asOf, onChange: (v) => setAsOf(v ?? dayjs()) })] }), _jsxs(Row, { gutter: 16, style: { marginBottom: 16 }, children: [_jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total Valuasi", value: parseFloat(q.data?.total_valuation ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#0F766E' } }) }) }), _jsx(Col, { span: 8, children: _jsx(Card, { children: _jsx(Statistic, { title: "Jumlah SKU", value: q.data?.rows.length ?? 0 }) }) })] }), _jsx(Card, { children: _jsx(Table, { rowKey: "sku", size: "middle", pagination: { defaultPageSize: 25 }, loading: q.isLoading, columns: cols, dataSource: q.data?.rows ?? [] }) })] }));
}
